import { SPINESIM_MODALITIES, MorphologyOrientation} from "../classes/enums/MedicalImagesEnum";

export const REFINE_CONFIG = [
    {
      modality: SPINESIM_MODALITIES.POSTURE,
      orientation: MorphologyOrientation.FRONT,
      key: "Posture-Front",
    },
    {
      modality: SPINESIM_MODALITIES.POSTURE,
      orientation: MorphologyOrientation.RIGHT,
      key: "Posture-Right",
    },
    {
      modality: SPINESIM_MODALITIES.POSTURE,
      orientation: MorphologyOrientation.BACK,
      key: "Posture-Back",
    },
    {
      modality: SPINESIM_MODALITIES.POSTURE,
      orientation: MorphologyOrientation.LEFT,
      key: "Posture-Left",
    },
    {
      modality: SPINESIM_MODALITIES.PAIN,
      key: "PAIN",
    },
    {
      modality: SPINESIM_MODALITIES.CLINICAL_HISTORY,
      key: "CLINICAL_HISTORY",
    },
  ];